/* global angular */

angular.module('AemCspsDpsPension')
  .controller('AemCspsDpsPensionCtrl', AemCspsDpsPensionCtrl)

require('./inlet.css')
var subYears = require('date-fns/fp/subYears').default
var startOfDay = require('date-fns/fp/startOfDay').default
var parseISO = require('date-fns/fp/parseISO').default
require('./services/generator.dataservice')
require('./services/predisbursement.service')

AemCspsDpsPensionCtrl.$inject = ['appLoader', 'widgetParamsService', 'generatorDataservice', 'predisbursementService', 'userTracking', '$locale', '$filter', '$location']

function AemCspsDpsPensionCtrl (appLoader, widgetParamsService, generatorDataservice, predisbursementService, userTracking, $locale, $filter, $location) {
  var vm = this
  var canceler = null

  vm.$onInit = function () {
    vm.submit = submit
    vm.isErrorBackend = false
    vm.onErrorOccured = onErrorOccured
    vm.onBirthDateChanged = onBirthDateChanged
    vm.locale = $locale.id
    vm.getParameterByName = getParameterByName

    widgetParamsService.get('AemCspsDpsPension')
      .then(function (res) {
        vm.birthDate = {
          min: parseISO('1900-01-01'),
          max: startOfDay(subYears(18)(Date.now())),
          default: parseISO('1970-01-01')
        }
        try {
          vm.birthDate = {
            min: parseISO(res.data.params.birthDate.min),
            max: startOfDay(subYears(res.data.params.birthDate.maxYears)(Date.now())),
            default: parseISO(res.data.params.birthDate.default)
          }
        } catch (e) {}
        vm.birthDate.value = vm.birthDate.default
        vm.gender = generatorDataservice.value('gender', res.data.params, { default: 'M' })
        vm.savingPeriod = generatorDataservice.value('savingPeriod', res.data.params, { min: 0, max: 600, default: 60, step: 1 })
        vm.totalSavingsAmount = generatorDataservice.value('totalSavingsAmount', res.data.params, { min: 0, max: 10000000, default: 0, step: 1000 })
        vm.desiredDisbursementPeriod = generatorDataservice.value('desiredDisbursementPeriod', res.data.params, { min: 24, max: 60, default: 24, step: 1 })
        if (getParameterByName('dayOfBirth') || getParameterByName('monthOfBirth') || getParameterByName('yearOfBirth')) {
          var defaultBirthDate
          var year = (getParameterByName('yearOfBirth') && getParameterByName('yearOfBirth') > vm.birthDate.min.getFullYear() && getParameterByName('yearOfBirth') < vm.birthDate.max.getFullYear())
            ? getParameterByName('yearOfBirth')
            : vm.birthDate.default.getFullYear()
          var month = getParameterByName('monthOfBirth') && getParameterByName('monthOfBirth') >= 1 && getParameterByName('monthOfBirth') <= 12
            ? getParameterByName('monthOfBirth')
            : vm.birthDate.default.getMonth() + 1
          var day = getParameterByName('dayOfBirth') ? getParameterByName('dayOfBirth') : vm.birthDate.default.getDate()
          if ((month + '').length < 2) {
            month = '0' + month
          }
          if ((day + '').length < 2) {
            day = '0' + day
          }
          defaultBirthDate = year + '-' + month + '-' + day
          vm.birthDate.value = parseISO(defaultBirthDate) + '' === 'Invalid Date' ? vm.birthDate.default : parseISO(defaultBirthDate)
        }
        if (getParameterByName('gender') && (getParameterByName('gender') === 'F' || getParameterByName('gender') === 'M')) {
          vm.gender.value = getParameterByName('gender')
        }
        initConditionsText(res.data.params)
        submit()
      })
      .catch(function () {
        vm.onErrorOccured()
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function onBirthDateChanged () {
    if (vm.birthDate.value === null) {
      vm.birthDate.value = vm.birthDate.default
    }
    if (vm.birthDate.value < vm.birthDate.min) {
      vm.birthDate.value = vm.birthDate.min
    }
    if (vm.birthDate.value > vm.birthDate.max) {
      vm.birthDate.value = vm.birthDate.max
    }
    submit()
  }

  function submit () {
    var data = {}
    data.yearOfBirth = vm.birthDate.value.getFullYear()
    data.monthOfBirth = vm.birthDate.value.getMonth() + 1
    data.dayOfBirth = vm.birthDate.value.getDate()
    data.gender = vm.gender.value
    data.savingPeriod = vm.savingPeriod.value
    data.totalSavingsAmount = vm.totalSavingsAmount.value
    data.desiredDisbursementPeriod = vm.desiredDisbursementPeriod.value
    if (canceler) {
      canceler.resolve()
    }
    userTracking.onRequest(data)
    var request = predisbursementService.getPredisbursement(data)
    canceler = request.canceler
    return request.promise
      .then(function (res) {
        userTracking.onResponse(res.data)
        vm.result = res.data
        parseConditionText(res.data)
      })
      .catch(function (err) {
        if (~err.status) {
          userTracking.onResponse(null, 'failed')
          vm.isErrorBackend = true
        }
      })
  }

  function onErrorOccured () {
    vm.isErrorBackend = true
  }

  function initConditionsText (params) {
    if ($locale.id === 'cs') {
      vm.ageConditionPar = params.ageCondition.cs
      vm.periodConditionPar = params.periodCondition.cs
      vm.savingsAmountConditionPar = params.savingsAmountCondition.cs
    }
    if ($locale.id === 'en') {
      vm.ageConditionPar = params.ageCondition.en
      vm.periodConditionPar = params.periodCondition.en
      vm.savingsAmountConditionPar = params.savingsAmountCondition.en
    }
  }

  // get parameter from url
  function getParameterByName (name) {
    var searchObject = $location.search()
    return searchObject[name]
  }

  function parseConditionText (data) {
    vm.ageCondition = vm.ageConditionPar.replace(/%ageConditionFulfill%/i, $filter('date')(data.ageConditionFulfill, 'd.M.yyyy'))
    vm.periodCondition = vm.periodConditionPar.replace(/%periodConditionFulfill%/i, data.periodConditionFulfill)
    vm.savingsAmountCondition = vm.savingsAmountConditionPar.replace(/%savingsAmountConditionFulfill%/i,
      $filter('currency')(data.savingsAmountConditionFulfill, undefined, 0))
  }
}
